<template>
	<div>
		<b-navbar class="has-box-shadow" wrapper-class="container" fixed-top :centered="!(HasPath('/login') || HasPath('/forgotPassword') || HasPath('/resetPassword') || HasPath('/instructions') || HasPath('/about')|| HasPath('/demo') || HasPath('/pricing'))">
			<template slot="brand" class="flex-center">
				<router-link href="/login" :to="'/login'" style="border: none;"><b-image :src="logo" style="max-width: 100px; cursor: pointer;" /></router-link>

			</template>
			<template slot="start">
				<b-navbar-item v-if="!HasPath('/login') && !HasPath('/forgotPassword') && !HasPath('/resetPassword')&& $store.getters.hasAccess" v-bind:class="{'is-active': HasPath('/aircraft')}" tag="router-link" :to="{ path: '/aircraft'}">
					Aircraft
				</b-navbar-item>
				<b-navbar-item v-if="!HasPath('/login') && !HasPath('/forgotPassword') && !HasPath('/resetPassword')&& $store.getters.hasAccess" v-bind:class="{'is-active': HasPath('/portfolio')}" tag="router-link" :to="{ path: '/portfolio'}">
					Portfolios
				</b-navbar-item>
				<b-navbar-dropdown label="About the calculator" hoverable>
					<b-navbar-item tag="router-link" :to="{ path: '/about'}">
						General
					</b-navbar-item>
					<b-navbar-item target="_blank" href="/AWG Carbon Calculator -- Terms of Use.pdf">
						Terms of use
					</b-navbar-item>
					<b-navbar-item target="_blank" href="/Calculation Methodology Document.pdf">
						Calculation Methodology Document
					</b-navbar-item>
					<b-navbar-item tag="router-link" :to="{ path: '/results'}">
						Results of ACC calculation and further information
					</b-navbar-item>
					<b-navbar-item tag="router-link" :to="{ path: '/demo'}">
						Demo video
					</b-navbar-item>
					<b-navbar-item tag="router-link" :to="{ path: '/instructions'}">
						Instructional video
					</b-navbar-item>
					<b-navbar-item tag="router-link" :to="{ path: '/pricing'}">
						Pricing
					</b-navbar-item>
					<b-navbar-item v-if="$store.getters.isLoggedIn" tag="router-link" :to="{ path: '/login'}">
						Login / request access
					</b-navbar-item>
				</b-navbar-dropdown>
				<b-navbar-item v-if="!HasPath('/login') && !HasPath('/forgotPassword') && !HasPath('/resetPassword')&& $store.getters.hasAccess" v-bind:class="{'is-active': HasPath('/contactus')}" tag="router-link" :to="{ path: '/contactus'}">
					Contact us
				</b-navbar-item>
			</template>
			<template slot="end" v-if="!HasPath('/login') && !HasPath('/forgotPassword') && !HasPath('/resetPassword')&& $store.getters.isLoggedIn">
				<b-navbar-dropdown :label="$store.getters.user.Name">
					<b-navbar-item @click="goToUserAccount" v-if="$store.getters.hasAccess">
						My Account
					</b-navbar-item>
					<hr class="dropdown-divider" aria-role="menuitem">
					<b-navbar-item @click="logout">
						<a>Logout</a>
					</b-navbar-item>
				</b-navbar-dropdown>
			</template>
		</b-navbar>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				logo: require('@/assets/pictures/CC-Logo.png')
			}
		},
		computed: {
			OnLogin() {
				if (this.$route.path == "/login" || this.$route.path == "/")
					return true;
				else
					return false;
			},
		},
		methods: {
			HasPath(path) {
				if (this.$route.path.indexOf(path) > -1)
					return true;
				else
					return false;
			},
			goToUserAccount() {
				window.location.href = this.$USERURL + "/user/account";
			},
			logout() {
				this.$store.dispatch("logout");
			}
		}
	}
</script>

<style>
	.justify-left {
		justify-content: left !important;
	}

	.navbar-start .is-active {
		background-color: whitesmoke !important;
		border-bottom: solid 3px rgb(158,190,72);
	}

	.banner-icon {
		cursor: pointer;
		padding: 10px 20px 10px;
	}

	#navbar a:hover {
		color: black !important;
	}

	.navbar-item {
		border: none;
	}

	#navigationHeader_navBar a {
		text-decoration-line: none;
		font-weight: 400;
	}

	#navbar .dropdown-item:hover {
		background-color: whitesmoke !important;
	}

	.navbar-link {
		border: none;
	}

	div.menu {
		display: none;
		position: absolute;
		background: #fff;
	}


		div.menu:hover, a:hover + div.menu {
			display: block;
			z-index: 999;
		}
</style>
